export const ORDER_NOW_BUTTON_CLICKS = 'order_now_btn_clicks';
export const CUSTOM_ORDER_SUBMIT = 'custom_order_submit';
